export default {
  SET_ROLE (state, role) {
    state.role = role
  },
  SET_EMAIL (state, email) {
    state.email = email
  },
  SET_USER (state, user) {
    if (user.id !== undefined) {
      state.id = user.id
    }
    if (user.email !== undefined) {
      state.email = user.email
    }
    if (user.fullname !== undefined) {
      state.fullname = user.fullname
    }
    if (user.work_in !== undefined) {
      state.work_in = user.work_in
    }
    if (user.role !== undefined) {
      state.role = user.role
    }
    if (user.status !== undefined) {
      state.status = user.status
    }
    if (user.signup !== undefined) {
      state.signup = user.signup
    }
    if (user.activated !== undefined) {
      state.activated = user.activated
    }
    if (user.last_login !== undefined) {
      state.last_login = user.last_login
    }
    if (user.credits !== undefined) {
      state.credits = user.credits
    }
    if (user.keywords_count !== undefined) {
      state.keywords_count = user.keywords_count
    }
    if (user.projects_count !== undefined) {
      state.projects_count = user.projects_count
    }
    if (user.reports_count !== undefined) {
      state.reports_count = user.reports_count
    }
    if (user.links_count !== undefined) {
      state.links_count = user.links_count
    }
    if (user.permissions !== undefined) {
      state.permissions = user.permissions
    }
    if (user.overridden_permissions !== undefined) {
      state.overridden_permissions = user.overridden_permissions
    }
    if (user.projects !== undefined) {
      state.projects = user.projects
    }
  },
  CLEAR_USER (state) {
    state.id = null
    state.email = null
    state.fullname = null
    state.phone_number = null
    state.work_in = null
    state.role = null
    state.status = null
    state.signup = null
    state.activated = null
    state.last_login = null
    state.credits = null
    state.keywords_count = 0
    state.projects_count = 0
    state.reports_count = 0
    state.links_count = 0
    state.permissions = null
    state.overridden_permissions = null
    state.projects = null
  }
}



// WEBPACK FOOTER //
// ./src/store/user/mutations.js